module.exports = __webpack_public_path__ + "img/energieagentur-white.67058a42.svg";